$("div#makeMeScrollable").smoothDivScroll({
  // always, onStart or empty (no auto scrolling) String
  autoScrollingMode: "always",
  // right, left, backAndForth, endlessLoopRight, endlessLoopLeft String
  autoScrollingDirection: "endlessLoopRight",
  // Pixels
  autoScrollingStep: 1,
  // Milliseconds
  autoScrollingInterval: 25,
  // Pause on hover
  autoScrollingPauseOnHover: false,
  // vertical, horizontal, allDirections or empty (no mousewheel scrolling) String
  mousewheelScrolling: "",
  // Config the hotspot scrolling.
  hotSpotScrolling: false,
  // always, onStart, hover or empty (no visible hotspots)
  visibleHotSpotBackgrounds: "",
});

$(".title").delay(1000).animate({ opacity: 1 });
$(".devider, .sub-title").delay(1300).animate({ opacity: 1 });
$(".main").delay(1600).animate({ opacity: 1 });
$(".footer").delay(1900).animate({ opacity: 1 });
